import React, {useState} from 'react';
import Button from "../../../components/button";
import InputForm from "../../../components/input-form";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";

const CloneComponent = ({state}) => {
    const [status, setStatus] = useState("")

    const {refetch} = useQuery({
        enabled: false,
        queryFn: () => projectService.getClone(state.code).then(({data}) => {
            data = JSON.parse(data)
            if (data.enabled){
                const status = {
                    DISABLE: "Desligado",
                    SHARE_ALL: "Geral",
                    RESTRICT: "Restrito",
                }

                setStatus(`Ligado (${status[data.mode]})`)

            }else{
                setStatus("Desligado")
            }
            return data
        }),
        queryKey: ['clone'],
    });
    const handleChange = (onOff) => {
        const data = {
            enabled: onOff
        }
        submit(data)
    }

    const submit = (cloneData) => {
        const formData = new FormData();
        Object.keys(cloneData).forEach(key => {
            formData.append(key, cloneData[key]);
        });

        formData.append('_method', 'POST');

        const response =  projectService.editClone(formData, state.code);

        response
            .then(() => {
                refetch()
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            });
    }

    return (
        <>
            <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12 mt-4 justify-between">
                <Button onClick={() => refetch()} col={"col-span-2"} target={"primary"}>
                    Status
                </Button>
                <Button onClick={() => handleChange(true)} col={"col-span-2"} target={"primary"}>
                    Ligar
                </Button>
                <Button onClick={() => handleChange(false)} col={"col-span-2"} target={"danger"}>
                    Desligar
                </Button>
                <InputForm id="clone" name="clone" col="col-span-6" value={status} disabled={true}/>
            </div>



        </>
    );
};

export default CloneComponent;